
if (!customElements.get('product-actions')) {
  customElements.define(
    'product-actions',
    class ProductActions extends HTMLElement {
      connectedCallback() {
        this.shareButton = this.querySelector('[data-product-actions-share]');
        this.shareLabel = this.querySelector('[data-product-actions-share-label]');
        this.whatsappLink = this.querySelector('[data-product-actions-whatsapp]');
        this.status = this.querySelector('[data-product-actions-status]');
        this.nextLink = this.querySelector('[data-product-actions-next]');

        this.pickRandomNext();

        this.onShare = this.share.bind(this);
        this.onWhatsapp = this.updateWhatsappLink.bind(this);

        this.shareButton?.addEventListener('click', this.onShare);
        this.whatsappLink?.addEventListener('click', this.onWhatsapp);
      }

      disconnectedCallback() {
        this.shareButton?.removeEventListener('click', this.onShare);
        this.whatsappLink?.removeEventListener('click', this.onWhatsapp);
        clearTimeout(this.copiedTimeout);
      }

      // Liquid renders a default link and a pool of candidates; pick one here so it varies per visit.
      pickRandomNext() {
        const pool = this.querySelector('[data-product-actions-next-pool]');
        if (!this.nextLink || !pool) return;

        let products;
        try {
          products = JSON.parse(pool.textContent);
        } catch (error) {
          return;
        }
        if (!products.length) return;

        const next = products[Math.floor(Math.random() * products.length)];
        this.nextLink.href = next.url;
        this.nextLink.title = next.title;
      }

      // The PDP rewrites the URL on variant change, so always share the live URL.
      get shareUrl() {
        return window.location.href;
      }

      get shareTitle() {
        return this.dataset.shareTitle || document.title;
      }

      updateWhatsappLink() {
        const text = `${this.shareTitle} ${this.shareUrl}`;
        this.whatsappLink.href = `https://wa.me/?text=${encodeURIComponent(text)}`;
      }

      async share() {
        if (navigator.share) {
          try {
            await navigator.share({ title: this.shareTitle, url: this.shareUrl });
          } catch (error) {
            // AbortError = shopper closed the share sheet; anything else falls back to copying.
            if (error.name !== 'AbortError') this.copyLink();
          }
          return;
        }

        this.copyLink();
      }

      async copyLink() {
        try {
          await navigator.clipboard.writeText(this.shareUrl);
        } catch (error) {
          this.legacyCopy(this.shareUrl);
        }
        this.showCopied();
      }

      // Fallback for browsers/contexts without the async Clipboard API (e.g. non-HTTPS previews).
      legacyCopy(text) {
        const field = document.createElement('textarea');
        field.value = text;
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.opacity = '0';
        document.body.appendChild(field);
        field.select();
        document.execCommand('copy');
        field.remove();
      }

      showCopied() {
        const message = this.dataset.copiedLabel;
        if (!message || !this.shareLabel) return;

        this.defaultShareLabel ??= this.shareLabel.textContent;
        this.shareLabel.textContent = message;
        this.shareButton.classList.add('is-copied');
        if (this.status) this.status.textContent = message;

        clearTimeout(this.copiedTimeout);
        this.copiedTimeout = setTimeout(() => {
          this.shareLabel.textContent = this.defaultShareLabel;
          this.shareButton.classList.remove('is-copied');
          if (this.status) this.status.textContent = '';
        }, 2500);
      }
    }
  );
}
